
import { fns, libTypes } from "@holta/lib";
import { useStore } from "../../config/store";
import { getEditOrder } from "./getEditOrder";
import {create} from 'mutative';

export const setDeliveryNotes = (deliveryNotes: libTypes.Order['deliveryNotes']) => {

    const editOrder = getEditOrder();

    useStore.setState({
        editOrder : create(editOrder, draft => {
            draft.newValues.order.deliveryNotes = fns.order.set.deliveryNotes(deliveryNotes);
        })
    });
};